module.exports = __webpack_public_path__ + "static/pod-banner-e82cfb89ec3fd2f40d9acb0ef7ff874d.png";